<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <ActionBar :show="false" v-model:search="query.search" v-model:start_date="query.start_date" v-model:end_date="query.end_date"/>
      </div>
    </template>

    <template #layoutContent>
      <div class="row">
        <div class="col-12">
          <Card class="card shadow-sm mb-5 p-5 px-10">
            <div class="d-flex justify-content-start align-items-center mt-2">
              <h3 class="mt-1"> {{ $t("expenses.filter.office") }} </h3>
            </div>

            <div class="row mt-5 pt-5" style="border-top: 2px solid #CCCFD3;">
              <OfficeCountCard class="mb-4"  v-for="office in officesWithExpensesCount" attr="expenses_count" :key="office.id" :office="office" v-model="query.office"/>
            </div>
          </Card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <Card class="card px-5 pt-5">
            <div class="d-flex flex-column flex-md-row justify-content-between">
              <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                <li class="nav-item">
                  <a @click.prevent="toggleTabs('office_tab_pane')" class="nav-link text-active-primary ms-0 me-10 py-5" :class="{ 'active' : currentTab === 'office_tab_pane' }" data-bs-toggle="tab" href="#office_tab_pane">{{$t("expenses.officeExpenses")}}</a>
                </li>
                <li class="nav-item">
                  <a @click.prevent="toggleTabs('fees_note_tab_pane')" class="nav-link text-active-primary ms-0 me-10 py-5" :class="{ 'active' : currentTab === 'fees_note_tab_pane' }" data-bs-toggle="tab" href="#fees_note_tab_pane">{{$t("expenses.feeNotes")}}</a>
                </li>
                <li class="nav-item">
                  <a @click.prevent="toggleTabs('recurrence_expense_tab_pane')" class="nav-link text-active-primary ms-0 me-10 py-5" :class="{ 'active' : currentTab === 'recurrence_expense_tab_pane' }" data-bs-toggle="tab" href="#recurrence_expense_tab_pane">{{$t("expenses.chargesFixes")}}</a>
                </li>
              </ul>
              <div class="text-md-end">
                <ButtonDropdownFilter
                    v-show="currentTab === 'office_tab_pane'"
                    btnClass=" h-35px"
                    :btn-title="$t('expenses.label.allStatus')"
                    :search="false"
                    :options="expenseStatus"
                    value-field="value"
                    :name-field="locale"
                    v-model="query.status"
                />

                <Button
                    btn-class="btn-sm ms-auto"
                    type="new"
                    btn-text="recurrentExpense.new.title"
                    v-if="$can(abilities.CREATE_EXPENSE_RECURRING) && currentTab === 'recurrence_expense_tab_pane'"
                    @click.prevent="router.push({ name: 'recurrence-expense-create', params: { office: query.office } })"/>
              </div>
            </div>
            <div class="tab-content" id="myTabContent">
              <div :class="{ 'active' : currentTab === 'office_tab_pane' }" class="tab-pane fade show" id="office_tab_pane" role="tabpanel">
                <Card class="card shadow-none card-custom border-0 position-relative">
                  <template #cardBody>
                    <div class="row mt-1 pt-2" >
                      <Card v-for="type in typeStats" :key="type.type" class="card shadow-none pt-0 pb-3 px-5 mb-5">
                        <div class="flex-lg-row flex-md-row d-flex scroll-x mt-5 py-5">
                          <StatCard :title="$t('expenses.total')" :amount="type.amount" :total="type.total" color="secondary" text-color="black" :size-md="4" :size-lg="2"/>
                          <StatCard :title="$t('expenses.status.remaining')" :amount="type.remaining_amount" :total="type.remaining_count" :color="type.remaining_color" :size-md="4" :size-lg="2"/>
                          <StatCard :title="$t('expenses.status.notValidated')" :amount="type.unvalidated_amount" :total="type.unvalidated_count" :color="type.unvalidated_color" :size-md="4" :size-lg="2"/>
                          <StatCard :title="$t('expenses.status.unapproved')" :amount="type.unapproved_amount" :total="type.unapproved_count" :color="type.unapproved_color" :size-md="4" :size-lg="2"/>
                          <StatCard :title="$t('expenses.status.rejected')" :amount="type.reject_amount" :total="type.reject_count" :color="type.reject_color" :size-md="4" :size-lg="2"/>
                          <StatCard :title="$t('expenses.status.validated')" :amount="type.validated_amount" :total="type.validated_count" :color="type.validated_color" :size-md="4" :size-lg="2"/>
                          <StatCard :title="$t('expenses.status.paid')" :amount="type.paid_amount" :total="type.paid_count" :color="type.paid_color" :size-md="4" :size-lg="2"/>
                        </div>
                      </Card>
                      <OfficeExpenseList id="office_expense_list" :officeExpenses="officeExpenses" :loading="isFetching" @reloadData="reloadData" />
                      <div :ref="loadMoreTrigger" class="loading" v-if="isFetching">
                        Chargement...
                      </div>
                    </div>
                  </template>
                </Card>
              </div>
              <div :class="{ 'active' : currentTab === 'fees_note_tab_pane' }" class="tab-pane fade show" id="fees_note_tab_pane" role="tabpanel">
                <Card class="card shadow-none card-custom border-0 position-relative">
                  <template #cardBody>
                    <div class="row mt-10" >
                      <UserExpensesStatList id="waiting" :users-expenses="unvalidatedExpenses" :office-id="query.office" :loading="isLoading"/>
                    </div>
                  </template>
                </Card>
              </div>
              <div :class="{ 'active' : currentTab === 'recurrence_expense_tab_pane' }" class="tab-pane fade show" id="recurrence_expense_tab_pane" role="tabpanel">
                <Card class="card shadow-none card-custom border-0 position-relative">
                  <template #cardBody>
                    <div class="row" >
                      <div class="d-flex justify-content-between align-items-center mb-4">

                      </div>
                      <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="recurrent-expense-datatable" style="margin-top: 13px !important; cursor:pointer">
                        <thead>
                        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                          <th> {{$t("recurrentExpense.label.title")}}</th>
                          <th> {{$t("recurrentExpense.label.expenseDate")}}</th>
                          <th> {{$t("recurrentExpense.label.amount")}}</th>
                          <th> {{$t("recurrentExpense.label.status")}}</th>
                          <th>{{$t("actions")}}</th>
                        </tr>
                        </thead>
                      </table>
                    </div>
                  </template>
                </Card>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </template>
  </SubLayout>
</template>

<script setup> 
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Card from "@/components/Card.vue";
import {onMounted, ref, computed, watch} from "vue";
import ActionBar from "./components/ActionBar.vue";
import {useRoute, useRouter} from "vue-router";
import { useStore } from "vuex";
import UserExpensesStatList from "./components/UserExpensesStatList.vue";
import Ls from "@/services/ls";
import OfficeCountCard from "@/components/OfficeCountCard.vue";
import OfficeExpenseList from "@/Modules/Financial/views/Accounting/components/OfficeExpenseList.vue";
import {useInfiniteScroll} from "@/composables/infiniteScroll";
import abilities from "@/composables/abilities";
import Button from "@/components/Button.vue";
import {BASE_URL} from "@/services/api";
import {$formatLocalAmount} from "@/mixins/Helpers";
import {Theme} from "@/composables/theming";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import StatCard from "@/Modules/Financial/components/StatCard.vue";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";

const { can } = useHasAbility()
const route = useRoute()
const store = useStore()
const router = useRouter();
const {locale, datatableLocaleUrl} = useLocales()


const title = ref("breadcrumbs.expenses.title")
const currentTab = ref("office_tab_pane")
const currentCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])

const office = route.params.id


const breadcrumbs = ref([
  {
    name: 'breadcrumbs.expenses.stats',
    route: 'office-users-expenses-overview',
    params: {id:office, company:route.params.company}
  }
])

const isLoading = ref(false)
const officeExpenses = ref([])
const unvalidatedExpenses = ref([])
const officesWithExpensesCount = ref([])
const currentPage = ref(1);
const lastPage = ref(null);
const table = ref(null)
const typeStats = ref([])


const query = ref({
  start_date: '',
  end_date: '',
  search: "",
  office: route.params.id,
  status: ''
})

const expenseStatus = computed(() => store.getters['expenses/expenseStatus'])

watch(() => currentCompanyId.value, async (value) => {
  if(value){
    await loadOfficesWithExpensesCount().then(() => {
      router.replace({name: route.name, params : { id : query.value.office , company : value }, query: { ...route.query }})
      loadOfficeUsersWithSomeStats()
    })
  }
})

watch(() => query.value, (value) => {

  currentPage.value = 1
  lastPage.value = null

  if (!isLoading.value) {
    loadOfficeUsersWithSomeStats()
    if(value.office) {
      router.replace({ name: route.name, params: { ...route.params, id: value.office }, query: { ...route.query } });
      fetchRecurrentExpenses()
    }
    loadOfficeExpenseList(true)
    loadOfficeExpenseStats()
  }

}, {deep: true})

watch(() => locale.value, () => {
  if(query.value.office) {
    fetchRecurrentExpenses()
  }
})

function toggleTabs(tab) {
  currentTab.value = tab
  router.replace({ query: { ...route.query, tab } });
}

const canLoadMore = () => lastPage.value === null || currentPage.value <= lastPage.value;
function loadOfficeUsersWithSomeStats () {
  if(query.value.end_date && query.value.start_date && currentCompanyId?.value &&  query.value.office){
    try {
      isLoading.value = true
      store.dispatch('expenses/loadAccountingOfficeUsersExpensesStats', query.value).then(resp => {
        //usersExpenses.value = resp.data.office
        unvalidatedExpenses.value = resp.data.users
      })
    }catch (e) {

    }finally {
    
      isLoading.value = false
    }
  }
  

}

async function loadOfficesWithExpensesCount () {

    if(!currentCompanyId?.value) return;
    try {
      isLoading.value = true
      store.dispatch('expenses/loadSocietyOfficesWithCount',  currentCompanyId?.value).then(resp => {
        isLoading.value = false
        officesWithExpensesCount.value = resp.data.data
        if(!officesWithExpensesCount?.value?.map(x=> x.id)?.includes(route.params.id)){
          query.value.office = officesWithExpensesCount.value[0]?.id
        }else{
          query.value.office = route.params.id
        }

      })
    }catch (e) {

    }finally {
    
      isLoading.value = false
    }
    
}

function loadOfficeExpenseList (clearOldData = false) {
  if(query.value.end_date && query.value.start_date){
    if (lastPage.value !== null && currentPage.value > lastPage.value) return;
    try {
      isLoading.value = true
      store.dispatch('expenses/loadOfficeExpenseList', {...query.value, page: currentPage.value}).then(resp => {
        currentPage.value = resp.data.expenses.current_page
        lastPage.value = resp.data.expenses.last_page

        if (clearOldData) {
          officeExpenses.value = [...resp.data.expenses.data]
        } else {
          officeExpenses.value = [...officeExpenses.value,...resp.data.expenses.data]
        }
      })
    }catch (e) {

    }finally {

      isLoading.value = false
    }
  }
}

const { loadMoreTrigger, isFetching } = useInfiniteScroll(loadOfficeExpenseList, canLoadMore)

function fetchRecurrentExpenses(){
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#recurrent-expense-datatable").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + `/get/${query.value.office}/expense/recurrentDataTable`,
      type: "GET",
      beforeSend: function (request, options) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [{ data: "title" }, {  data: "date" }, {  data: "amount" }, {  data: "status" }, { data: "Actions", responsivePriority: -1 }],
    columnDefs: [
      {
        targets: -5,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + "</span>";
        },
      },
      {
        targets: -4,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + "</span>";
        },
      },
      {
        targets: -3,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' +  $formatLocalAmount(t)  + "</span>";
        },
      },
      {
        targets: -2,
        order: "desc",
        render: function (t, a, e, l) {
          let color = t ? 'success' : 'danger'
          let text = t ? 'recurrentExpense.label.enable' : 'recurrentExpense.label.disable'
          return  `<span class="badge badge-${color} me-3"> ${ i18n.global.t(text) } </span>`;
        },
      },
      {
        width: "15%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render=""
          if(can(abilities.VIEW_EXPENSE_RECURRING)) {
            render += '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon show_btn" ><i data-row="' + l.row + '" data-id="' + e.id + '" class="fas fa-eye fs-2" data-toggle="tooltip" data-placement="top" title="' + i18n.global.t('button.show') + '" style="color: ' + Theme.gray + '"></i></a>'
          }
          if(can(abilities.UPDATE_EXPENSE_RECURRING)) {
            render += '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon edit_btn" ><i data-row="' + l.row + '" data-id="' + e.id + '" class="fas fa-edit fs-2" data-toggle="tooltip" data-placement="top" title="' + i18n.global.t('button.edit') + '" style="color: ' + Theme.gray + '"></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url:  datatableLocaleUrl.value
    }
  });

  $(document).on("click", "#recurrent-expense-datatable .show_btn", (e) => {
    const target = e.target.closest('#recurrent-expense-datatable .show_btn');
    e.preventDefault()
    e.stopImmediatePropagation()
    router.push({ name: 'recurrence-expense-view', params: {id: target.getAttribute('data-id')} });
  });

  $(document).on("click", "#recurrent-expense-datatable .edit_btn", (e) => {
    const target = e.target.closest('#recurrent-expense-datatable .edit_btn');
    e.preventDefault()
    e.stopImmediatePropagation()
    router.push({ name: 'recurrence-expense-edit', params: {id: target.getAttribute('data-id')} })
  });

}

function loadOfficeExpenseStats () {
  if(query.value.end_date && query.value.start_date){
    store.dispatch('expenses/loadOfficeExpenseStats', query.value).then(resp => {
      typeStats.value = resp.data.types
    })
  }
}

function reloadData() {
  loadOfficesWithExpensesCount()
  loadOfficeUsersWithSomeStats()
  loadOfficeExpenseList(true)
  loadOfficeExpenseStats()
}

onMounted(() => {
  loadOfficesWithExpensesCount()
  loadOfficeUsersWithSomeStats()
  loadOfficeExpenseList()
  loadOfficeExpenseStats()
  if(route.query.tab){
    currentTab.value = route.query.tab
  }
})

</script>
